
import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoriesSection from './components/CategoriesSection';
import AboutPreview from './components/AboutPreview';
import GallerySection from './components/GallerySection';
import ReviewsSection from './components/ReviewsSection';
import LocationSection from './components/LocationSection';

export default function HomePage() {
  useEffect(() => {
    document.title = 'High Standards Smoke Shop Eustis Florida - Premium Vapes Glass Hookah';

    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

    const schema = {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'High Standards Smoke Shop',
      description:
        'High Standards Smoke Shop in Eustis, Florida offers premium vapes, fine glass, hookah, shisha, CBD products and curated accessories.',
      url: siteUrl,
      telephone: '+13529774832',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '1321 S Bay St',
        addressLocality: 'Eustis',
        addressRegion: 'FL',
        postalCode: '32726',
        addressCountry: 'US',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 28.8528,
        longitude: -81.6851,
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          opens: '10:00',
          closes: '20:00',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Sunday'],
          opens: '09:00',
          closes: '22:00',
        },
      ],
      sameAs: [
        'https://www.instagram.com/highstandardsmoke?igsh=MXd0YTRobGI0MWUzZw%3D%3D',
        'https://www.tiktok.com/@highstandards.smokes',
      ],
      priceRange: '$$',
      image: `${siteUrl}/og-image.jpg`,
      hasMap: 'https://maps.google.com/?q=1321+S+Bay+St,+Eustis,+FL+32726',
      currenciesAccepted: 'USD',
      paymentAccepted: 'Cash, Credit Card',
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-home';
    script.textContent = JSON.stringify(schema);
    const existing = document.getElementById('schema-home');
    if (existing) existing.remove();
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById('schema-home');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="bg-deep-black min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <CategoriesSection />
        <AboutPreview />
        <GallerySection />
        <ReviewsSection />
        <LocationSection />
      </main>
      <Footer />
    </div>
  );
}
